/**
 * Normalize the request URL by replacing numeric segments with a wildcard and removing trailing slashes.
 * This helps in grouping similar requests together in observability tools like New Relic.
 */
export const normalizedRequestUrl = (url: string): string => {
  if (url === '') return ''

  return url.toLowerCase().replaceAll(/\/\d+/g, '/*').replace(/\/$/, '') || '/'
}
